import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from './components/Icon';
import { IconButton } from './components/IconButton';
import { TOGGLE_BUTTON_TEST_ID, TOGGLE_ICON_TEST_ID } from './constants';

import type { SidebarAnimatedComponentsState } from 'applications/GSP/layouts/MainLayout/components/Sidebar/types';
import type { FC } from 'react';

interface ToggleButtonProps extends SidebarAnimatedComponentsState {
  onClick: (opened: boolean) => void;
}

export const ToggleButton: FC<ToggleButtonProps> = ({ opened, onClick }) => {
  const { t } = useTranslation();
  const handleToggleButton = useCallback(() => {
    onClick(!opened);
  }, [onClick, opened]);

  return (
    <IconButton
      data-testid={TOGGLE_BUTTON_TEST_ID}
      color="primary"
      onClick={handleToggleButton}
      aria-label={
        opened
          ? t('GSP.layouts.mainLayout.sidebar.toggleButton.ariaLabel.collapse')
          : t('GSP.layouts.mainLayout.sidebar.toggleButton.ariaLabel.expand')
      }
    >
      <Icon data-testid={TOGGLE_ICON_TEST_ID} opened={opened} />
    </IconButton>
  );
};
